module.exports = __webpack_public_path__ + "img/data-wwd-design.7ed582e8.png";